import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';
import { showSnackbar } from '../../../api/snackbarSlice';

export const downloadReportJob = async (jobId, { dispatch, insufficientAccessMessage, defaultFileName }) => {
  try {
    const response = await apiClient.get(`/jobs/${jobId}/download`, {
      skipErrorSnackbar: true,
      responseType: 'blob',
    });
    const blob = new Blob([response.data], {
      type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = defaultFileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 403) {
      dispatch(
        showSnackbar({
          message: insufficientAccessMessage,
          severity: 'error',
        }),
      );
      return;
    }
    const message =
      error instanceof AxiosError ? error.response?.data?.errors?.message || error.message : String(error);
    dispatch(showSnackbar({ message, severity: 'error' }));
  }
};
